<script setup>
const { tenantName } = defineProps({
    tenantName: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <div
        class="mb-4 flex flex-wrap items-center justify-between gap-2 text-2xl font-semibold"
    >
        <slot />

        <div v-if="$slots.actions">
            <slot name="actions" />
        </div>

        <div
            v-if="tenantName"
            class="rounded-full bg-indigo-600 px-2 py-1 text-sm text-white"
        >
            {{ tenantName }}
        </div>
    </div>
</template>
